import { Center } from '@chakra-ui/react';
export default function NotAuthenticatedErrorPage({ minH }) {
  return (
    <Center minH={minH} fontWeight="bold" fontSize={58}>
      <h1>User is not authenticated</h1>
    </Center>
  );
}
